// extracted by mini-css-extract-plugin
export default {"root":"root___cUPBx","title":"title___F9pjA","links":"links___Mw81y","link":"link___Yc7Ah","icon_left":"icon_left___o9zU1","icon_right":"icon_right___jRzBn"};